module.exports = __webpack_public_path__ + "static/media/file.bab4f201.svg";